module.exports = __webpack_public_path__ + "static/media/regis.5652c466.png";